import { render, staticRenderFns } from "./aShopDetailOrder.vue?vue&type=template&id=78011a38&scoped=true"
import script from "./aShopDetailOrder.vue?vue&type=script&lang=js"
export * from "./aShopDetailOrder.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailOrder.vue?vue&type=style&index=0&id=78011a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78011a38",
  null
  
)

export default component.exports